<template>
  <div class="landing-page landing-page-home">
    <header class="pt-0">
      <public-header :term="search" @doSearch="doSearch"></public-header>
      <img src="@/assets/lp/images/clouds.png" alt="" class="clouds" />
      <section class="container-fluid section-1">
        <div class="row">
          <div class="col-md-6"><img src="@/assets/lp/images/banner-1.png" alt="" class="img-fluid" /></div>
          <div class="col-md-6">
            <h2>
              MUNDIPLAY: a plataforma digital que<br />
              dá um play no seu conhecimento!
            </h2>
            <h3>
              Coloque sua empresa à frente, ofereça conteúdos educacionais<br />
              aos seus clientes e colaboradores.
            </h3>
            <a href="/login" target="_blank" class="btn">Ensine com a gente</a> <img src="@/assets/lp/images/banner-2.png" alt="" class="img-fluid" />
          </div>
        </div>
      </section>
    </header>
    <img src="@/assets/lp/images/fx-1.png" alt="" class="fx-1" /> <img src="@/assets/lp/images/fx-2.png" alt="" class="fx-2" />
    <img src="@/assets/lp/images/fx-3.png" alt="" class="fx-3" /> <img src="@/assets/lp/images/fx-4.png" alt="" class="fx-4" />
    <!-- <section class="container-fluid section-2 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2>Cursos em destaque</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <v-progress-linear v-if="loadingCourses" indeterminate></v-progress-linear>
          <carousel v-else :per-page="3" :navigate-to="0" :mouse-drag="false" :navigationEnabled="true" >
            <slide v-for="(course, $index) in courses" :key="$index">
              <v-card
                class="mx-auto text-center"
                max-width="400"
              >
                <v-img
                  class="white--text align-center"
                  height="200px"
                  :src="getCourseImage(course.image)"
                >
                  <v-card-title class="white--text">{{ course.title }}</v-card-title>
                </v-img>

                <v-card-actions class="text-center align-center py-4">
                  <a href="" target="_blank" class="btn blue">Ver mais</a>
                </v-card-actions>
              </v-card>
            </slide>
          </carousel>
        </div>
      </div>
    </section> -->
    <section class="container-fluid section-3 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
      <div class="row">
        <div class="col-md-6">
          <h2>
            Aprender sempre, a cada momento<br />
            e em todo lugar
          </h2>
          <h3>
            Acreditamos na expansão do conhecimento sem barreiras. Por isso, o MUNDIPLAY é a nova plataforma digital de conteúdos educacionais que acaba de chegar no Brasil.<br />
            <br />
            Com uma plataforma ágil e intuitiva, em poucos instantes você poderá disponibilizar conhecimento e aprendizagem para a sua equipe e seus clientes.
          </h3>
        </div>
        <div class="col-md-6"><img src="@/assets/lp/images/banner-3.png" alt="" class="img-fluid" /></div>
      </div>
    </section>
    <section class="container-fluid section-4 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
      <div class="row">
        <div class="col-md-6"><img src="@/assets/lp/images/banner-4.png" alt="" class="img-fluid destaque" /></div>
        <div class="col-md-6">
          <h2>Como tornar tudo isso real?</h2>
          <h3>Além da nossa plataforma digital, onde você disponibiliza conteúdos educacionais, a sua empresa tb conta com:</h3>
          <div class="row produtos">
            <div class="col-md-5"><img src="@/assets/lp/images/mp-studio.png" alt="" class="img-fluid" /></div>
            <div class="col-md-7">
              <p>A central de produção audiovisual <b>Mundiplay Studio,</b> produz conteúdos especializados dentro da área da educação, especialmente pensados para a sua empresa.</p>
            </div>
          </div>
          <div class="row produtos">
            <div class="col-md-5"><img src="@/assets/lp/images/mp-develop.png" alt="" class="img-fluid" /></div>
            <div class="col-md-7">
              <p>
                A <b>Mundiplay Develop</b> reúne uma equipe especializada em desenvolvimento tecnológico, com ampla experiência no mercado educacional e integrando a plataforma com as ferramentas que
                a sua empresa já
                utiliza.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container-fluid section-4 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s" data-wow-offset="40">
      <div class="row">
        <div class="col-md-5">
          <h2>Faça parte dessa inovação</h2>
          <h3>
            Vamos transformar a educação da sua empresa<br />
            de forma segura e personalizada.
          </h3>
          <a href="/login" target="_blank" class="btn">Ensine com a gente</a>
        </div>
        <div class="col-md-7"><img src="@/assets/lp/images/banner-5.png" alt="" class="img-fluid" /></div>
      </div>
    </section>
    <footer class="lp"><img src="@/assets/lp/images/mundi-play-logo-rodape.png" alt="" /></footer>
  </div>
</template>

<script>
  // @ is an alias to /src
  import '@/assets/lp/style.css'
  import '@/assets/lp/animate.min.css'
  import { mapActions, mapGetters } from 'vuex'
  import PublicHeader from '@/components/Public/Header'
  import {WOW} from 'wowjs'
  // import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'PublicHome',
    components: { PublicHeader },
    // components: {
    //   Carousel,
    //   Slide
    // },
    data: () => ({
      navigationEnabled: false,
      drawer: false,
      loadingCourses: false,
      courses: []
    }),
    created() {
      // this.getCourses()
    },
    computed: {
      ...mapGetters(['getPublicFilters']),
      search: function () {
        return this.getPublicFilters.term || ''
      }
    },
    mounted () {
      var wow = new WOW({
          live: false
      });
      wow.init()
    },
    methods: {
      ...mapActions(['setPublicFilters']),
      getCourses () {
        this.loadingCourses = true
        this.axios.get('/public/course/featured').then(({ data }) => {
          if (data.success) {
            this.courses = data.courses
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          this.loadingCourses = false
        })
      },
      doSearch () {
        this.$router.push({ name: 'busca' })
      }
      // getCourseImage (fileName) {
      //   return `${process.env.VUE_APP_API_EAD_URL}/public/course/image/${fileName}`
      // }
    }
  }
</script>
